import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import { usePreviewContext } from '../../../campaignPreview/contexts/PreviewContext.jsx';
import { setScrollPosition } from '../../../../lib/redux/campaignScroll/campaignScrollSlice';

import Text from '../../../../shared/Text';
import { NewTag } from '../Tiles/NewTag.jsx';
import { TileImage } from '../Tiles/TileImage';

export const TileCard = ({ tile, campaignId, isNew, postIndex }) => {
  const dispatch = useDispatch();
  const previewContext = usePreviewContext();
  const location = useLocation();
  const { thumbnail, ribbonTagName, ribbonTagColor } = tile;

  const viewUrl = () => {
    if (previewContext) return `/tile/${tile.id}?preview=true`;

    const isInPlanRouter = location.pathname.startsWith('/campaigns/');
    const prefix = isInPlanRouter ? '/campaigns' : '';
    return `${prefix}/${campaignId}/tile/${tile.id}?preview=true`;
  };

  return (
    <Container id={tile.id} isNew={isNew} key={tile.id}>
      <ViewLink
        to={viewUrl}
        onClick={() =>
          dispatch(
            setScrollPosition({
              page: 'preview',
              scrollPosition: window.scrollY,
            }),
          )
        }
      >
        <TileImage
          thumbnail={thumbnail}
          ribbonTagName={ribbonTagName}
          ribbonTagColor={ribbonTagColor}
        />
        <Headline variant="small1">{tile.headline}</Headline>
        {isNew && postIndex > 0 && <NewTag />}
      </ViewLink>
    </Container>
  );
};

const Container = styled.div`
  border-radius: 8px;
  background: ${themeGet('colors.white')};
  border: 1px solid ${themeGet('colors.black.10')};
  cursor: grab;
  position: relative;
  opacity: ${({ isNew }) => (isNew ? 1 : 0.5)};
  width: 190px;
  box-shadow: 0 2px 3px rgb(0 0 0 / 22%);
`;

const ViewLink = styled(Link)`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  height: 200px;
  width: 190px;
`;

const Headline = styled(Text)`
  padding: 10px;
`;
